<div class="grid">
  <div class="col-12 mb-2">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i *ngIf="mode == 'create'" class="pi pi-plus-circle mr-1 title-card-icon"></i>
            <i *ngIf="mode == 'edit'" class="pi pi-pencil mr-1 title-card-icon"></i>
          </div>
          <div>
            <p class="mb-0 text-3xl title">
              {{ (mode == 'create' ? 'misc.creation.sequence' : 'misc.edition.sequence') | transloco | capitalize }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4 xl:col-3">
    <p-timeline [value]="items" align="left" styleClass="timeline-hidden-opposite lg:pr-2">
      <ng-template let-item pTemplate="marker">
        <span
          [class]="(item.index != currentStep) ? (item.index < currentStep) ? 'step-completed' : 'step-inactive' : 'step-active'"
          class="custom-marker p-shadow-1"
        >
          <i [ngClass]="(item.index >= currentStep) ? item.icon : 'pi pi-check'" class="text-white"></i>
        </span>
      </ng-template>
      <ng-template let-item pTemplate="content">
        <div class="card flex justify-content-between align-items-center mb-4">
          <h4 [class]="(item.index != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'">
            {{ item.label | transloco }}
          </h4>
          <i
            *ngIf="item.description"
            [class]="(item.index != currentStep) ? 'step-text-inactive mb-0' : 'step-text-active mb-0'"
            [pTooltip]="item.description | transloco"
            class="pi pi-info-circle text-xl"
            tooltipPosition="top"
            tooltipStyleClass="device-info-tooltip"
          ></i>
        </div>
      </ng-template>
    </p-timeline>
  </div>

  <div class="col-12 lg:col-8 xl:col-9">
    <div *ngIf="currentStep === 0">
      <app-sequence-form-info
        (nextStep)="onNextStep()"
        (onCancel)="onCancel($event)"
        (sequencePersistRequestChange)="sequencePersistRequest = $event"
        [(sequence)]="sequence"
        [formLoaded]="formLoaded"
        [mode]="mode"
        [tenants]="tenants"
      ></app-sequence-form-info>
    </div>
    <div *ngIf="currentStep == 1">
      <app-sequence-form-configuration
        (nextStep)="onNextStep()"
        (onCancel)="onCancel($event)"
        (prevStep)="onPreviousStep()"
        (sequenceConfigurationChange)="sequence.configuration = $event; sequencePersistRequest.configuration = $event"
        (showErrors)="visible = true"
        [assetSchemaJson]="asset"
        [errors]="errors"
        [mode]="mode"
        [sequenceConfiguration]="sequence.configuration"
      ></app-sequence-form-configuration>

    </div>
    <div *ngIf="currentStep == 2">
      <div class="card">
        <div class="flex flex-column p-1 sm:p-3">
          <h2>{{ 'model.sequence' | transloco }} {{ sequence.name }}</h2>
          <h4 class="mt-4 bold">{{ 'common.information' | transloco }}</h4>
          <div class="grid my-2">
            <div class="flex flex-column col-12 lg:col-6 xl:col-4">
              <div class="mt-3">
                <p class="bold p-0 m-0">{{ 'attribute.name' | transloco }}</p>
                <p>{{ sequence.name }}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{ 'model.tenant' | transloco }}</p>
                <p>{{ sequence.tenant.name }}</p>
              </div>
              <div class="mt-3">
                <p class="bold p-0 m-0">{{ 'model.organization' | transloco }}</p>
                <p
                  [class.font-italic]="!sequence.organization">{{ sequence?.organization ? sequence?.organization?.name : ('empty.organization' | transloco) }}</p>
              </div>
              <div class="mt-3">
                <ng-container *ngIf="sequence.recurrentSequenceConfig !== undefined">
                  <p class="bold p-0 m-0">{{ 'misc.sequence.scheduleType.recurrent' | transloco }}</p>
                  <p
                    [class.font-italic]="!sequence.recurrentSequenceConfig">{{ sequence.recurrentSequenceConfig.recurrentTime }}
                    {{ 'date.minutes' | transloco }}</p>
                </ng-container>

                <ng-container *ngIf="sequence.scheduledSequenceConfig !== undefined">
                  <p class="bold p-0 ml-0 mt-0 mr-0 mb-1">{{ 'misc.sequence.scheduleType.daily' | transloco }}</p>
                  <app-sequence-schedule-card
                    [scheduledSequenceConfig]="sequence.scheduledSequenceConfig"></app-sequence-schedule-card>
                </ng-container>
              </div>

            </div>
          </div>

          <div class="flex flex-row">
            <h4 class="mt-4 bold">{{ 'forms.configuration' | transloco }}</h4>
          </div>
          <div class="my-2">
            <ngx-json-viewer *ngIf="sequence.configuration" [json]="sequence.configuration"></ngx-json-viewer>
            <p *ngIf="!sequence.configuration" class="text-center"><i>{{ 'empty.technicalDetails' | transloco }}</i></p>
          </div>

          <div class="mt-6">
            <div class="flex flex-column sm:flex-row justify-content-between">
              <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
                <button
                  (click)="onPreviousStep()"
                  [label]="'common.previous' | transloco"
                  class="flex-1 sm:flex-none"
                  icon="pi pi-angle-left"
                  iconPos="left"
                  pButton
                  pRipple
                ></button>
                <button
                  (click)="persistSequenceData()"
                  [label]="(mode == 'creation' ? 'common.create' : 'common.save') | transloco"
                  [loading]="persistingChanges"
                  class="p-button-primary ml-2 flex-1 sm:flex-none"
                  pButton
                  pRipple
                ></button>
              </div>
              <button
                (click)="onCancel(null)"
                [label]="'common.cancel' | transloco"
                class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
                pButton
                pRipple
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [header]="('error.sequences.configuration.invalid' | transloco)"
  [modal]="true"
  [resizable]="true"
  [style]="{ width: '90vw' }"
  appendTo="body"
  closeOnEscape="true"
>
  <app-sequence-form-configuration-errors
    [errors]="errors"
    [sequenceConfiguration]="sequencePersistRequest.configuration">
  </app-sequence-form-configuration-errors>
</p-dialog>
